<div class="image-container">
  <div class="image-border">
    <img
      width="110px"
      height="110px"
      [ngClass]="{
        'image-silhouette': !imageSrc,
      }"
      [src]="imageSrc ?? '/assets/images/silhouette.png'"
      [attr.data-cy]="imageSrc ? 'modal-consult-photo' : 'modal-consult-silhouette'"
      alt="{{ imageSrc ? 'consultant photo' : 'image placeholder' }}"
    >
  </div>
</div>